import { useEffect, useState } from "react";
import { useLang } from "@/i18n";

const LAUNCH_DATE = new Date("2026-09-24T20:00:00+02:00").getTime();

export default function Countdown() {
  const { t } = useLang();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, LAUNCH_DATE - now);
  const days = Math.ceil(diff / 86400000);

  return (
    <div data-testid="launch-countdown" className="mt-6 inline-flex items-center gap-2.5 border border-white/10 bg-[#0A0A0A] rounded-full px-4 py-2">
      <span className="w-1.5 h-1.5 rounded-full bg-[#CCFF00] pulse-dot" />
      <span className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-zinc-400">
        {t.countdown.label} <span className="text-[#CCFF00] font-bold">{days} {t.countdown.days}</span>
      </span>
    </div>
  );
}
